import { AuxiliumComponent } from "../auxilium-component";

export default class Grid extends AuxiliumComponent {
	static observable = ["gap", "alignment", "columns", "columns-sm", "columns-md", "columns-lg", "columns-xl", "columns-xxl"];

	#applyColumns() {
		const columns = parseInt(this.getAttribute("columns")) || 0,
			columnsSmall = parseInt(this.getAttribute("columns-sm")) || 0,
			columnsMedium = parseInt(this.getAttribute("columns-md")) || 0,
			columnsLarge = parseInt(this.getAttribute("columns-lg")) || 0,
			columnsExtraLarge = parseInt(this.getAttribute("columns-xl")) || 0,
			columnsExtraExtraLarge = parseInt(this.getAttribute("columns-xxl")) || 0;

		if ([columns, columnsSmall, columnsMedium].some(x => x)) {
			if (columns) { Browser.AddCssRule(this, `--grid-columns: ${columns};`); };
			if (columnsSmall) { Browser.AddCssRule(this, `--grid-columns-sm: ${columnsSmall};`); };
			if (columnsMedium) { Browser.AddCssRule(this, `--grid-columns-md: ${columnsMedium};`); };
			if (columnsLarge) { Browser.AddCssRule(this, `--grid-columns-lg: ${columnsLarge};`); };
			if (columnsExtraLarge) { Browser.AddCssRule(this, `--grid-columns-xl: ${columnsExtraLarge};`); };
			if (columnsExtraExtraLarge) { Browser.AddCssRule(this, `--grid-columns-xxl: ${columnsExtraExtraLarge};`); };
		}
	}

	parsedCallback() {
		this.#applyColumns();

		const list = document.createElement("ul");

		[...this.childNodes ?? []].filter(x => x.nodeType !== Node.TEXT_NODE || x.textContent.trim())
			.forEach(item => this.addItem(item, list));

		this.appendChild(list);
	}

	addItem(item, list) {
		list ??= this.firstElementChild;

		if (!list) {
			list = this.appendChild(document.createElement("ul"));
		}

		const listItem = document.createElementWithContents("li", item);

		if (item.columnSpan) { Browser.AddCssRule(listItem, `--column-span: ${item.columnSpan}`); }
		if (item.rowSpan) { Browser.AddCssRule(listItem, `--row-span: ${item.rowSpan}`); }

		list.appendChild(listItem);
	}
	
	addItems(items) {
		items.forEach(item => this.addItem(item));
	}

	attributeChanged(name) {
		if (name.startsWith("columns")) {
			this.#applyColumns();
		}
	}
}
